export default "__VITE_ASSET__CgWGgRAU__"